import domReady from '@wordpress/dom-ready';
/* Ajax */
let currentPage = 1;
let ajaxIsLoading = false;
let isDoneLoadingThings = false;
let currentUrl = window.location.href;

domReady( () => {
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
  const $ = jQuery.noConflict();

  if ( $('.archive-block').length ) {
    $('.archive-block').each(function(){
      const archiveBlock = $(this);
      const archiveFeed = $(this).find('.archive-block__feed');
      const archivePagination = $(this).find('.archive-block__pagination-container');

      const archiveFilterForm = $(this).find('.archive-block__header');
      const archiveSortInputs = $(this).find('.archive-block__sort__input-input');
      const archiveSearchInput = $(this).find('.archive-block__search-input');
      const archiveSearchConfirm = $(this).find('.archive-block__search-confirm');

      const archiveFilterGroups = $(this).find('.archive-block__filter');


      const base = $(this).data('baseurl');
      let currentURL = $(this).data('currenturl');
      const initPage = $(this).data('page');
      const postType = $(this).data('posttype');
      const exclude = $(this).data('exclude');
      const nonce = $(this).data('nonce');

      let updateArchive;
      let stateObj = {
        base: base,
        url: currentURL,
        page: initPage,
        sort: 'default',
        postType: postType,
        search: false,
        mode: false,
        exclude: exclude,
        taxonomy: false,
        term: false,
        filters: {},
        constantFilters: this.hasAttribute('data-constantfilters') ? $(this).data('constantfilters') : [],
        nonce: nonce
      };

      if ( this.hasAttribute('data-postsper') ) {
        stateObj.postsPerPage = $(this).data('postsper');
      }

      if ( this.hasAttribute('data-cardargs') ) {
        stateObj.cardArgs = $(this).data('cardargs');
      }
      
      if ( this.hasAttribute('data-taxonomy') ) {
        stateObj.taxonomy = $(this).data('taxonomy');
      }
      
      if ( this.hasAttribute('data-term') ) {
        stateObj.term = $(this).data('term');
      }
      
      if ( this.hasAttribute('data-mode') ) {
        stateObj.mode = $(this).data('mode');
      }
      
      if ( this.hasAttribute('data-searchterm') ) {
        stateObj.search = $(this).data('searchterm');
      }

      const updateURLFromFilters = () => {
        const baseurl = base[0] === '/' ? window.location.protocol + base : base;
        const url = new URL(baseurl);
        if ( stateObj.sort !== 'default' ) {
          url.searchParams.append('sort', stateObj.sort);
        }

        if ( stateObj.mode === 'search' && stateObj.search !== false ) {
          url.searchParams.append('s', stateObj.search);
        } else if ( stateObj.search !== false ) {
          url.searchParams.append('search', stateObj.search);
        }

        if ( Object.keys(stateObj.filters).length ) {
          for ( const filterType in stateObj.filters ) {
            if ( Array.isArray(stateObj.filters[filterType]) ) {
              url.searchParams.append(filterType, stateObj.filters[filterType].join(','));
            } else {
              url.searchParams.append(filterType, stateObj.filters[filterType]);
            }
          }
        }

        stateObj.url = url.toString();
        stateObj.page = 1;

        updateArchive();
      };

      if ( archiveFilterGroups.length ) {
        $(archiveFilterGroups).each(function() {
          const inputs = $(this).find('input');

          $(inputs).each(function(){
            const name = $(this).attr('name');
            const type = $(this).attr('type');
            const val = $(this).attr('value');

            if ( $(this).is(':checked') ) {
              if ( type === 'radio' ) {
                stateObj.filters[ name ] = val;
              } else {
                if ( stateObj.filters.hasOwnProperty(name) ) {
                  stateObj.filters[ name ].push( val );
                } else {
                  stateObj.filters[ name ] = [ val ];
                }
              }
            }

            $(this).on('change', function(){
              if ( $(this).is(':checked') ) {
                if ( type === 'radio' ) {
                  stateObj.filters[ name ] = val;
                } else {
                  stateObj.filters[ name ].push( val );
                }
              } else if ( type === 'checkbox' ) {
                stateObj.filters[ name ] = stateObj.filters[name].filter( e => e !== val );
              } else if ( type === 'hidden' ) {
                stateObj.filters[ name ] = $(this).val();
              }
              
              updateURLFromFilters();
            });
          });
        });
      }

      if ( archiveSortInputs.length ) {
        $(archiveSortInputs).each(function(){
          const val = $(this).attr('value');
          
          if ( $(this).is(':checked') ) {
            stateObj.sort = val;
          }
          
          $(this).on('change', function(){
            if ( $(this).is(':checked') ) {
              stateObj.sort = val;
              updateURLFromFilters();
            }
          });
        });
      }

      if ( archiveSearchInput.length ) {
        if ( archiveSearchInput.val() !== '' ) {
          stateObj.search = archiveSearchInput.val();
        }
      }

      if ( archiveSearchConfirm.length ) {
        archiveSearchConfirm.on('click', function(){
          const searchQuery = archiveSearchInput.val();
          if ( searchQuery !== '' ) {
            if ( stateObj.search !== searchQuery ) {
              stateObj.search = searchQuery;
            }

            updateURLFromFilters();
          } else {
            if ( stateObj.search !== false ) {
              stateObj.search = false;
              updateURLFromFilters();
            }
          }
        });
      }

      if ( archiveFilterForm.length ) {
        archiveFilterForm.on('submit', function(e){
          e.preventDefault();
          if ( archiveSearchConfirm.length ) {
            archiveSearchConfirm.trigger('click');
          }
        });
      }



      $(archivePagination).on('click', 'a', function(e){
        e.preventDefault();
        if ( ajaxIsLoading === false ) {
          const url = $(e.target).attr('href');
          let page = 1;
          const urlparts = url.split('?')[0].split('/');
          let parsedNum = false;
          for ( let i = urlparts.length - 1; i >= 0; i-- ) {
            if ( urlparts[ i ] != '' ) {
              const parsed = parseInt( urlparts[ i ] );
              if ( !isNaN(parsed) ) {
                parsedNum = parsed;
                break;
              }
            }
          }

          if ( parsedNum !== false ) {
            page = parsedNum;
          }

          console.log(page);


          stateObj.url = url;
          stateObj.page = page;

          updateArchive();
        }
      }).on('keypress', 'a', function(e){
        e.preventDefault();
        $(this).trigger('click');
      });

      const initState = stateObj;

      window.addEventListener('popstate', function(event){
        if ( Object.keys(event.state).length == 0 ) {
          stateObj = initState;
        } else {
          stateObj = event.state;
        }

        updateArchive(true);
      });


      updateArchive = (frompopstate = false) => {
        ajaxIsLoading = true;
        $(archiveBlock).addClass('loading');
        gsap.to(window, {
          scrollTo: archiveBlock.get(0),
          duration: 0.8,
          ease: 'power1.inOut'
        });


        if ( frompopstate === false ) {
          history.pushState(stateObj, '', stateObj.url);
        }

        const args = {
          paged: stateObj.page,
          base: stateObj.base,
          sort: stateObj.sort,
          postType: stateObj.postType,
          exclude: stateObj.exclude,
          taxonomy: stateObj.taxonomy,
          term: stateObj.term,
          mode: stateObj.mode
        };

        if ( stateObj.search !== false ) {
          args.search = stateObj.search;
        } if ( stateObj.hasOwnProperty('postsPerPage') ) {
          args.postsPerPage = stateObj.postsPerPage;
        } if ( stateObj.hasOwnProperty('cardArgs') ) {
          args.cardArgs = stateObj.cardArgs;
        } if ( stateObj.hasOwnProperty('filters') && Object.keys(stateObj.filters).length ) {
          args.filters = stateObj.filters;
        } if ( stateObj.hasOwnProperty('constantFilters') && stateObj.constantFilters.length ) {
          args.constantFilters = stateObj.constantFilters;
        }

        console.log(args);

        $.post(robinkencelVars.ajaxURL, {
          action: 'robinkencel_get_archive',
          _wpnonce: stateObj.nonce,
          args: args
        }, function(data) {
          console.log(data);
          try {
            const res = JSON.parse(data);
            console.log(res);

            $(archiveFeed).html( res.results );
            $(archivePagination).html( res.pagination );
          } catch (err) {
            console.log( err );
          }
        }).always(function(){
          $(archiveBlock).removeClass('loading');
          ajaxIsLoading = false;
        });
      };
    });
  }
});